import { ListItem, ListItemIcon, ListItemText } from '@mui/material';
import NotificationsIcon from '@mui/icons-material/NotificationsActive';
import { NotificationSetting } from 'features/notifications/notifications.types';

type RegionItemProps = {
  regionSetting: NotificationSetting;
};

export const RegionItem = (props: RegionItemProps): JSX.Element => {
  const { regionSetting } = props;
  const { displayName } = regionSetting.region;

  return (
    <ListItem divider sx={{ px: 2, py: 1.5 }}>
      <ListItemIcon sx={{ minWidth: 0, mr: 1.5, color: 'text.secondary' }}>
        <NotificationsIcon />
      </ListItemIcon>
      <ListItemText
        primary={displayName}
        slotProps={{ primary: { fontWeight: 'fontWeightBold' } }}
      />
    </ListItem>
  );
};
